import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: `${API_BASE}/api`, withCredentials: true });

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('clm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      // Portal has its own auth surface — don't kick portal users to staff /login.
      if (path.startsWith('/portal')) {
        return Promise.reject(err);
      }
      localStorage.removeItem('clm_token');
      localStorage.removeItem('clm_user');
      if (!path.includes('/login') && !window.location.hash.includes('session_id')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
